import React from 'react';
import { FilterSecondary } from 'src/domains/layouts/webview/components/filtersSecondary/FilterSecondary';
import { FilterSecondaryBetBuilder } from 'src/domains/layouts/webview/components/filtersSecondary/FilterSecondaryBetBuilder';
import { FiltersSecondaryListSecondRow } from 'src/domains/layouts/webview/components/filtersSecondary/FiltersSecondary.style';
import { RabState } from 'src/domains/sportsbook/betting/state/rabState/RabState';
import { MarketFiltersForSportState } from 'src/domains/sportsbook/state/marketFiltersState/MarketFiltersForSportState';
import { MarketFiltersState } from 'src/domains/sportsbook/webview/components/marketFilters/MarketFilters.state';
import { observer } from 'src/utils/mobx-react';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';

interface PropsType {
    marketFiltersForSport: MarketFiltersForSportState;
    eventId: EventId;
    rabState: RabState;
}

export const MarketFilters = observer('MarketFilters', ({ marketFiltersForSport, eventId, rabState }: PropsType) => {
    const filtersState = new MarketFiltersState(marketFiltersForSport);
    const { filters, activeFilter } = filtersState;

    const { isBetBuilderOpen } = rabState;

    const onBetBuilerClick = (): void => {
        rabState.toggleOpenForEvent(eventId);
    };

    let newFilters = filters;

    if (rabState.isAvailableForEvent(eventId)) {
        const [first, ...rest] = filters;

        if (first) {
            newFilters = [first, { key: 'bet-builder', label: 'Bet Builder', onClick: onBetBuilerClick }, ...rest];
        }
    }

    return (
        <FiltersSecondaryListSecondRow>
            {newFilters.map((item) => {
                const { key, label, isDisabled, onClick } = item;
                const select = isBetBuilderOpen ? 'bet-builder' : activeFilter;
                const isActive = key === select;

                if (key === 'bet-builder') {
                    return (
                        <FilterSecondaryBetBuilder
                            isActive={isActive}
                            {...(!isBetBuilderOpen && { onClick })}
                        />
                    );
                }

                return (
                    <FilterSecondary
                        key={key}
                        onClick={() => {
                            onClick();
                            if (select === 'bet-builder') {
                                onBetBuilerClick();
                            }
                        }}
                        isActive={isActive}
                        data-is-active={isActive}
                        isDisabled={isDisabled}
                        dataTestFilterKey={key}
                    >
                        {label}
                    </FilterSecondary>
                );
            })}
        </FiltersSecondaryListSecondRow>
    );
});
